const SECRET = 's4tuS3h4t-d0kt3rpr0';

export function encrypt(text) {
    try {
        const encoded = encodeURIComponent(text);
        let result = '';
        for (let i = 0; i < encoded.length; i++) {
            result += String.fromCharCode(encoded.charCodeAt(i) ^ SECRET.charCodeAt(i % SECRET.length));
        }
        return btoa(result);
    } catch (e) {
        return '';
    }
}

export function decrypt(text) {
    try {
        const decoded = atob(text);
        let result = '';
        for (let i = 0; i < decoded.length; i++) {
            result += String.fromCharCode(decoded.charCodeAt(i) ^ SECRET.charCodeAt(i % SECRET.length));
        }
        return decodeURIComponent(result);
    } catch (e) {
        return '';
    }
}
